import { createEntry } from '@atlassian/jira-route-entry/src/index.tsx';
import { ROUTE_GROUPS_CLASSIC_SOFTWARE } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { projectDetailsResource } from '@atlassian/jira-router-resources-business-project-details/src/index.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { softwareFormSubmitEmbedClassicRoute } from '@atlassian/jira-router-routes-classic-projects-routes/src/softwareFormSubmitEmbedClassicRoute.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import {
	FormSubmitEmbedPage,
	LazyFormSubmitEmbedView,
} from '@atlassian/jira-router-routes-software-form-submit-embed-entries/src/ui/index.tsx';

export const softwareFormSubmitEmbedClassicRouteEntry = createEntry(
	softwareFormSubmitEmbedClassicRoute,
	() => ({
		group: ROUTE_GROUPS_CLASSIC_SOFTWARE,
		ufoName: 'classic-form-submit-embed',
		component: componentWithFG('jsw_forms_embed', FormSubmitEmbedPage, ErrorPagesNotFound),
		layout: chromelessLayout,
		navigation: {
			menuId: MENU_ID.PROJECTS,
		},
		resources: [projectDetailsResource],
		forPaint: [LazyFormSubmitEmbedView],
	}),
);
